import { useState } from "react";
import exitIcon from "../../../../icons/exit.png";
import styles from "./QuizExitButton.module.scss";
import { AppContext } from "../../../../components/Menu/MenuButton";
import { ExitPopup } from "../../../../components/Popup/ExitPopup/ExitPopup";
import { useDispatch } from "../../../../hooks";
import { abortQuiz } from "../../../../redux/quizzes/abort-quiz.handler";
import { ActionsContext } from "../../../ActionsPage/ACtionsRoutes";
import { useNavigate } from "react-router-dom";

export const QuizExitButton = () => {
    const [showExitPopup, setShowExitPopup] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const handleExitClick = () => setShowExitPopup(true);
    const handleCancelExit = () => setShowExitPopup(false);

    const handleClose = () => {
        dispatch(abortQuiz());
        navigate(`/${AppContext.Actions}/${ActionsContext.Tasks}`, { replace: true });
    }

    return (
        <>
            <img
                src={exitIcon}
                alt="exit"
                className={styles.exitIcon}
                onClick={ handleExitClick }
            />

            { showExitPopup &&
                <ExitPopup
                    title="Вы уверены, что хотите выйти из викторины?"
                    description="Ваш прогресс в викторине не сохранится"
                    onClose={ handleClose }
                    onCancel={ handleCancelExit }
                />
            }
        </>
    );
}